import { Component, OnInit, Input } from '@angular/core';
import { SetService, JwtService, PageService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { HttpService } from 'ngx-block-core';
import { FormControlService } from "ngx-block-core";
import { selectSize, iconTheme, eventTypeInput } from "../../../data/data";
import { ActivatedRoute } from '@angular/router';
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-sucu04-weiget0010002',
  styleUrls: ['./sucu04-weiget0010002.component.less'],
  templateUrl: './sucu04-weiget0010002.component.html',
})
export class Sucu04Weiget0010002Component implements OnInit {
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'
  @Input() acl = '';
  value
  @Input() sets = {
    blockCode: "sucublock54",
    blockId: "",
    blockName: "翻译输入框",
    layoutId: "",
    blockType: 'formBlock',
    blockChildType: '',
    versionCode: 10,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    sets: {
      acl: false
    },
    styles: {
      nzTextColor: "",
      nzSize: "small",
      nzPlaceHolder: "请输入内容",
      nzPassword: false,
      nzHidden: false,
      nzNoSee: false,
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzRequired: false,
      nzHasFeedback: true,
      nzReadOnly: true,
      nzIcon: {
        nzIconType: '',
        nzIconTheme: ''
      },
      nzExpandId: "",
    },
    datas: {
      nzSearchDataType: "string|array",
      nzSearchType: "like",
      nzSameTableCalculate: {
        nzUsed: false,
        nzFormula: "",
        nzReplaceValue: [
          // {
          //   name:"@v1",
          //   field:"",
          // }
        ]
      },
      nzFormGetData: {
        nzUsed: false,
      },
      nzEvents: [

      ],
      nzEventsDatas: {
      },
      nzLinkage: {
        nzUsed: false,
        nzEvents: [
          // {
          //   blockid:blockid,
          //   type:"value"//value,datasource
          // }
        ],//blockid
      },
      nzLinkageData: {
        nzDynamicSql: ""
      }
    }
  };

  setData = []

  constructor(
    public setService: SetService,
    public formControlService: FormControlService,
    private activatedRoute: ActivatedRoute,
    private http: HttpService,
    private jwtService: JwtService,
    private pageService: PageService
  ) { }

  autoUpdate() {
    if (this.sets.versionCode < 8) {

      this.sets.datas.nzEvents = [];
      this.sets.datas.nzEventsDatas = {};

      this.sets.versionCode = 8;
    }
    //vc:9
    //附加事件大整改
    if (this.sets.versionCode < 9) {
      for (const key in this.sets.datas.nzEventsDatas) {
        const element = this.sets.datas.nzEventsDatas[key];
        element['dataArray'] = [
          element['datas']
        ];
        element['dataArray'][0]['blockid'] = element['blockid']


      }

      this.sets.versionCode = 9;
    }
    if (this.sets.versionCode < 10) {

      this.sets.styles['nzExpandId'] = "";
      this.sets.versionCode = 10;
    }

  }
  ngOnInit() {
    this.baseInit();
    this.autoUpdate();
    let control_name = this.nzFormGroupData.nzKey;
    this.form.get(control_name).valueChanges.pipe(
      filter(control_name => control_name !== ""),
      //同valueChanges，不写也可
      distinctUntilChanged(),
      //防抖时间，单位毫秒
      debounceTime(600),
    ).subscribe((val) => {
      console.log("valueChangesval", val);
      this.formControlService.dataEvent(val, this.nzFormGroupData, this.blockid)
      if (this.needCalculate.used) {
        this.setService.events[this.needCalculate.id].emit({
          type: 'changeCalculateValue',
        });
      }

      if (this.sets.datas.nzFormGetData.nzUsed) {
        console.log("加载表单事件");
        this.formControlService.form_getData(this.setService.pageDatas['form_data_' + this.layoutid], this.setService.pageDatas['form_' + this.layoutid], this.activatedRoute);
      }
      //联动
      if (this.sets.datas.nzLinkage.nzUsed) {
        this.sets.datas.nzLinkage.nzEvents.forEach(element => {
          console.log("element", JSON.stringify(element));
          this.setService.sendEvent(element.blockid, "linkage" + element.type, { value: val })
        });
      }
      //事件
      this.sets.datas.nzEvents.forEach(element => {
        this.sets.datas.nzEventsDatas[element]['dataArray'].forEach(itemEvents => {
          switch (element) {
            case 'sendSimpleEvent':
              // this.endEvent.push(element);

              switch (itemEvents['name']) {
                case "search":
                  if (val !== null && val !== undefined) {
                    let data = {};
                    if (itemEvents['param1'] === '' || itemEvents['param1'] === null || itemEvents['param1'] === undefined) itemEvents['param1'] = '=';
                    data[itemEvents['param0']] = [
                      {
                        "name": itemEvents['param1'],
                        "type": "",
                        "instruction": "",
                        "value1": val,
                        "value2": ""
                      }
                    ]
                    this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'], data)
                    console.log("jsonsss", JSON.stringify(this.sets.datas.nzEventsDatas[element]), data)
                  }

                  break;

                default:
                  this.setService.sendEvent(itemEvents['blockid'], itemEvents['name'])
                  break;
              }

              break;

            default:
              break;
          }
        });

      });
    });
    //
    if (this.sets.styles.nzReadOnly) this.form.get(this.nzFormGroupData.nzKey).disable();
    else this.form.get(this.nzFormGroupData.nzKey).enable();

    this.linkageValue();
  }


  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              { name: 'nzLinkage', inputs: { otherSets: ['sql'], nzBlockSets: this.sets } },
            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'nzLayout'
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必填* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.form.get(this.nzFormGroupData.nzKey).disable();
                    else
                      this.form.get(this.nzFormGroupData.nzKey).enable();
                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "string|array";
                  }
                }
              },
            ]
          },
        ]
      },
      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      },
      {
        tabName: '高级功能',
        datas: [

          {
            type: 'datas',
            data: [
              { name: "nzEvents", inputs: { eventType: eventTypeInput } }
            ]
          },
        ]
      }
    ]
  }
  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "string|array";
        if (this.nzFormGroupData['nzSearchType'] == 'null')
          this.nzFormGroupData['nzSearchType'] = "like";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
    this.Listening()
  }
  ngOnDestroy() {
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
  }


  pzListening() {
    setTimeout(() => {
      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        switch (data['type']) {
          case 'changeFormValid':
            this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
            break;
          case 'openCalculate':
            if (data.datas == true) {

              this.initCalculate();
            } else {
              this.sets.datas.nzSameTableCalculate.nzUsed = false;
              this.initCalculate(false)
            }
            break;

          default:
            break;
        }
      }
      )
    }, 100);

  }

  /**
   * 计算功能初始化
   */
  initCalculate(open = true) {
    if (this.sets.datas.nzSameTableCalculate.nzUsed || open == false) {
      this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {

        this.setService.events[element.field].emit({
          type: 'needCalculate',
          datas: {
            used: open,
            id: this.blockid,
            name: element.name
          }
        });
      });
      if (open)
        this.calculateValue()
    }
  }
  /**
   * 计算数值
   */
  calculateValue() {
    let nzFormula = this.sets.datas.nzSameTableCalculate.nzFormula;
    //取值,替换值
    this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {
      const value = this.form.get(this.calculate_name_key[element.name]).value;
      nzFormula = nzFormula.replace(new RegExp(element.name, "gm"), value);
    });

    try {
      this.form.get(this.nzFormGroupData.nzKey).patchValue(eval(nzFormula));
    } catch (error) {

    }


  }
  needCalculate = {
    used: false,
    id: "",
    name: ""
  };
  calculate_name_key = {}
  Listening() {
    console.log("Listening", this.blockid)
    setTimeout(() => {
      this.setService.initEvent(this.blockid);
      this.setService.events[this.blockid].subscribe(
        data => {
          switch (data['type']) {
            case 'needCalculate':
              //通知目标积木更新值后通知回来
              this.needCalculate = data.datas;
              this.setService.events[this.needCalculate.id].emit({
                type: 'setCalculate',
                datas: {
                  name: this.needCalculate.name,
                  key: this.nzFormGroupData.nzKey
                }
              });
              break;
            case 'setCalculate':
              this.calculate_name_key[data.datas.name] = data.datas.key;
              break;
            case 'changeCalculateValue':
              this.calculateValue()
              break;
            case 'linkagevalue':
              this.linkageValue(data.datas.value, '')
              break;
            case 'linkagevalue2':
              this.linkageValue(data.datas.value, '2')
              break;
            case 'linkagevalue3':
              this.linkageValue(data.datas.value, '3')
              break;

            default:
              break;
          }


        }
      )
      setTimeout(() => {
        this.initCalculate()
      }, 100);
    }, !this.static ? 100 : 0);


  }

  // ngModelChange(value) {

  linkValue = {
    linkage: "",
    linkage2: "",
    linkage3: ""
  }
  // }
  label = "";
  linkageValue(value = "", type = "") {

    this.linkValue['linkage' + type] = value;
    let sql = this.sets.datas.nzLinkageData.nzDynamicSql;

    if (typeof this.linkValue.linkage != "undefined" && this.linkValue.linkage != "" && this.linkValue.linkage != null) sql = sql.replace(new RegExp("@linkage1", "gm"), this.linkValue.linkage);
    if (typeof this.linkValue.linkage2 != "undefined" && this.linkValue.linkage2 != "" && this.linkValue.linkage2 != null) sql = sql.replace(new RegExp("@linkage2", "gm"), this.linkValue.linkage2);
    if (typeof this.linkValue.linkage3 != "undefined" && this.linkValue.linkage3 != "" && this.linkValue.linkage3 != null) sql = sql.replace(new RegExp("@linkage3", "gm"), this.linkValue.linkage3);

    let body = {
      // "dynamicSql": 'select test001_name as value from t_test001 where test001_id=16',
      "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(sql), this.layoutid),
      "pageSize": 0,
      "nowPage": 0,
      "paramMap": [],
      "tableSort": [],
      "searchMap": {
      }
    }
    console.log("body:" + JSON.stringify(body));
    if (sql.indexOf("@linkage") == -1 && body.dynamicSql !== '') {
      this.http.postHttp("/system/dynamicSql", body).subscribe(
        (data: any) => {
          console.log("dynamicSql:" + JSON.stringify(data));
          if (data.data.list.length > 0) {
            this.form.get(this.nzFormGroupData.nzKey).patchValue(data.data.list[0]['VALUE'])
            this.label = data.data.list[0]['LABEL'];
          }
        })
    }

  }


}
